import * as React from 'react'
import classnames from 'classnames'

export interface Props {
  text?: React.ReactNode
  description?: React.ReactNode
  htmlFor?: string
  displayClasses?: string
  hideLabel?: boolean
}

const Label: React.FC<Props> = ({
  text,
  description,
  displayClasses,
  htmlFor,
  children,
  hideLabel,
}) => {
  const classes = classnames('label', displayClasses)
  const cls = classnames('label__text', {'u-hidden-visually': hideLabel})
  return (
    <label className={classes} htmlFor={htmlFor}>
      {text && <div className={cls}>{text}</div>}
      {description && <div className="label__description">{description}</div>}
      {children}
    </label>
  )
}

export default Label
